module.exports = __webpack_public_path__ + "img/home_icon.6654b967.svg";